import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-847d05f8"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["src"];
import { ref, onMounted, onUnmounted, reactive } from "vue";
import gsap from "gsap";
export default /*#__PURE__*/ _defineComponent({
    __name: 'arrow',
    props: ['rotate', 'canHover', 'isWhite'],
    setup(__props) {
        const { rotate, canHover, isWhite } = __props;
        const arrow = ref(null);
        const maskContainer = ref(null);
        const mask = ref(null);
        const observer = reactive({
            instance: null
        });
        onMounted(() => {
            // Initialize Intersection Observer
            observer.instance = new IntersectionObserver(handleIntersection, {
                root: null,
                rootMargin: "0px",
                threshold: 1
            });
            // Observe target element
            observer.instance.observe(maskContainer.value);
        });
        onUnmounted(() => {
            // Cleanup Observer
            if (observer.instance) {
                observer.instance.disconnect();
            }
        });
        function handleIntersection(entries, observer) {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    playAnimation();
                    observer.unobserve(entry.target);
                }
            });
        }
        function playAnimation() {
            if (rotate === 'right') {
                gsap.timeline({ repeat: 0 }) // Create a timeline with no repeat
                    .fromTo(arrow.value, { x: "-100%", opacity: 1 }, // Initial state (off-screen to the left and invisible)
                { x: "0%", y: '5px', opacity: 1, duration: 0.3, ease: "sine.out" } // Final state (halfway into view and visible)
                )
                    .to({}, { duration: 1, delay: 0.6 }) // Pause for 1 second in the middle
                    .to(arrow.value, { x: "200%", y: '5px', opacity: 1, duration: 0.3, ease: "sine.in" }, // Move off-screen to the right and fade out
                ">-0.5" // Use relative positioning to start this animation 0.5 seconds before the previous animation ends
                )
                    .fromTo(arrow.value, { x: "-100%", y: '5px', opacity: 1 }, // Initial state (off-screen to the left and invisible)
                { x: "0%", y: '5px', opacity: 1, duration: 0.3, ease: "sine.out" } // Final state (halfway into view and visible)
                )
                    .to({}, { onComplete: addHoverClass }); // Add the hover class once complete
            }
            else {
                gsap.fromTo(arrow.value, { y: "-100%", opacity: 1 }, // initial state (off-screen and invisible)
                { y: 40, opacity: 1, duration: 1, ease: "bounce.out", onComplete: addHoverClass } // final state (on-screen and visible)
                );
            }
        }
        function addHoverClass() {
            // Add the hover class once the animation has finished
            if (canHover) {
                mask.value.classList.add('mask__hover');
            }
        }
        function getImageSource() {
            if (isWhite) {
                return '/images/down-arrow-white.svg';
            }
            if (rotate === 'right') {
                return '/images/right-arrow-orange.svg';
            }
            else {
                return '/images/down-arrow-orange.svg';
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                ref_key: "maskContainer",
                ref: maskContainer,
                class: "mask-container"
            }, [
                _createElementVNode("div", {
                    ref_key: "mask",
                    ref: mask,
                    class: _normalizeClass(["mask", { 'mask__right_arrow': __props.rotate === 'right', 'mask__hover': __props.canHover }])
                }, [
                    _createElementVNode("img", {
                        ref_key: "arrow",
                        ref: arrow,
                        class: "arrow",
                        src: getImageSource(),
                        alt: "Down arrow",
                        loading: "lazy"
                    }, null, 8, _hoisted_1)
                ], 2)
            ], 512));
        };
    }
});
